
export function findOrError<T extends Element>(selector: string, element?: HTMLElement) {
    const root = element ?? document;
    const found = root.querySelector<T>(selector);
    if (!found) throw new ElementNotFound(selector);
    return found;
}

export class ElementNotFound extends Error {
    constructor(selector: string) {
        super(`element not found by selector ${selector}`);
    }
}